/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobTemplateIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TemplateJobTemplateIdQueryOperator");
    }

    getFixupPrototypeFunction() { return TemplateJobTemplateIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobTemplateIdQueryOperator>): TemplateJobTemplateIdQueryOperator {
        let obj = Object.assign(new TemplateJobTemplateIdQueryOperator(), model);
        TemplateJobTemplateIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobTemplateIdQueryOperator>): TemplateJobTemplateIdQueryOperator {
        if (!model) return null;
        return TemplateJobTemplateIdQueryOperator.newInstance(<TemplateJobTemplateIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobTemplateIdQueryOperator) {
        if (!obj) return;

        models.TemplateJobTemplateIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobTemplateIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplateJobTemplateIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template IDs to include
     */
    template_ids: Array<string>;

}
